import { render, staticRenderFns } from "./centerIndex.vue?vue&type=template&id=b57a5d92&scoped=true&"
import script from "./centerIndex.vue?vue&type=script&lang=js&"
export * from "./centerIndex.vue?vue&type=script&lang=js&"
import style0 from "./centerIndex.vue?vue&type=style&index=0&id=b57a5d92&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b57a5d92",
  null
  
)

export default component.exports